var _path, _path2, _path3, _path4, _path5, _rect, _line, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirCondition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 298 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.57 139.029C118.57 139.029 115.287 143.712 115.415 150.394C115.543 157.076 119.009 161.982 119.009 161.982C119.009 161.982 123.133 166.566 123.21 173.249C123.287 179.932 119.448 184.935 119.448 184.935",
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.433 138.958C149.433 138.958 146.15 143.64 146.277 150.323C146.405 157.005 149.872 161.911 149.872 161.911C149.872 161.911 153.996 166.495 154.073 173.178C154.15 179.861 150.311 184.864 150.311 184.864",
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180.295 138.958C180.295 138.958 177.012 143.64 177.14 150.323C177.268 157.005 180.734 161.911 180.734 161.911C180.734 161.911 184.859 166.495 184.935 173.178C185.012 179.861 181.173 184.864 181.173 184.864",
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M273 82.5H26C22.9624 82.5 20.5 84.9624 20.5 88V98H278.5V88C278.5 84.9624 276.038 82.5 273 82.5Z",
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 4V13C18 17.4183 21.5817 21 26 21H273C277.418 21 281 17.4183 281 13V4",
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 293,
    height: 114,
    rx: 7.5,
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 134.5,
    y1: 63.5,
    x2: 163.5,
    y2: 63.5,
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 249.5,
    cy: 64.5,
    r: 3.5,
    fill: "#808080"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 64.5,
    r: 3.5,
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirCondition);
export default __webpack_public_path__ + "static/media/air-condition.cffb10a27b622da9b6b8c2e791b15641.svg";
export { ForwardRef as ReactComponent };